/* istanbul ignore file */
import type {ControllerFlowAPI, HttpResponse} from '@wix/yoshi-flow-editor';
import type {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import type {RequestOptionsFactory} from '@wix/http-client/dist/src/types';
import type {ErrorCodesMapConditionalEnforcement} from '@wix/error-handler';
import {SPECS} from '../../common/constants';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';

export const ambassadorWithHeaders = <T>(
  req: RequestOptionsFactory<T>,
  siteStore: SiteStore,
  viewerContext: ViewerContext,
  flowAPI: ControllerFlowAPI,
  errorCodesMap: ErrorCodesMapConditionalEnforcement<HttpResponse<T>>,
  currency?: string
) => {
  const currencyHeader = currency ? {'x-wix-currency': currency} : {};
  const multilingualHeader = getMultilingualHeader(flowAPI, siteStore, viewerContext);
  const params = {headers: {...currencyHeader, ...multilingualHeader}};

  return flowAPI.errorHandler.withErrorHandler(
    () => flowAPI.essentials.httpClient.request((args) => ({...req(args), ...params})),
    {errorCodesMap}
  );
};

export const getMultilingualHeader = (
  flowAPI: ControllerFlowAPI,
  siteStore: SiteStore,
  viewerContext: ViewerContext
): Record<string, string> => {
  const currentLanguage = getCurrentLanguage(flowAPI);
  if (!currentLanguage) {
    return {};
  }
  const storeId = viewerContext.isExperimentEnabled(SPECS.MoveCheckoutToViewerContext)
    ? viewerContext.getEcomPlatformInstanceId()
    : siteStore.storeId;

  return {
    'x-wix-linguist': `${currentLanguage.languageCode}|${
      currentLanguage.locale
    }|${currentLanguage.isPrimaryLanguage.toString()}|${storeId}`,
  };
};

export const getCurrentLanguage = (flowAPI: ControllerFlowAPI) => {
  const {multilingual} = flowAPI.environment;
  if (!multilingual?.isEnabled) {
    return undefined;
  }

  return multilingual.siteLanguages.find((lang) => lang.languageCode === multilingual.currentLanguage);
};
